import React, { useState } from 'react';
import ParagraphText from 'components/Elements/ParagraphText/ParagraphText';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import LoginForm from 'features/auth/components/LoginForm';

/**
 * Renders a view with a welcome message and Login
 * Form. Users are able to sign in with their credentials
 * @returns
 */
function Login() {
  const [isEmailMode, setIsEmailMode] = useState(false);

  return (
    <AuthCard>
      <AuthFormHeader>
        <ParagraphText marginTop={10}>
          {isEmailMode
            ? 'Use your email to sign in to your account.'
            : 'My TXT'}
        </ParagraphText>
      </AuthFormHeader>
      <LoginForm onEmailModeChange={setIsEmailMode} />
    </AuthCard>
  );
}

export default Login;
